import { useEffect, useRef, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, A11y, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import Model from "../../components/model/Model";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import SideCard from "../../components/thirdsideCard/SideCard";
import PreLoader from "../../components/preloader/PreLoader";
import { setServiceNames } from "../../store/slices/IdSlice";
import FloatingMenuButton from "../../components/floatingMenu/FloatingMenuButton";
import FloatingMenuSection from "../../components/FloatingMenuSection/FloatingMenuSection";
import SecondRightSideCard from "../../components/thirdsideCard/SecondRightSideCard";
import { MainCategory, TrustPoints } from "../../types/service";
import PackageDescriptionModel from "../../components/typeofvisaComponents/footerModel/PackageDescriptionModel";
import HandleModel from "../../components/handleModel/HandleModel";
import UpdateModel from "../../components/model/UpdateModel";
import { TooltipLink } from "../../components/TooltipLink/TooltipLink";
import NewModel from "../../components/model/newModel";
import { useCart } from "../../hooks/useCart";
import { fetchServices } from "../../lib/api";
// import { fetchServices, getJsonData } from "../../lib/api";
import CartPackage from "../../components/cartPackage/CartPackage";
import HandleReadFullPolicyModel from "../../components/handleModel/HandleReadFullPolicyModel";
import HandlePackageAndServiceModel from "../../components/handleModel/HandlePackageAndServiceModel";
import PackageList from "./PackageList";
import ChatWithUs from "../../components/chatWithus/ChatWithUs";
import Coupons from "../../components/coupons/Coupons";

const baseUrl = import.meta.env.VITE_API_URL;

const PackagesMain = () => {
  const { getData } = useCart();
  const navigate = useNavigate();
  const slug = "packages";
  const [datas, setData] = useState<MainCategory[]>([]);
  const [trustPoints, setTrustPoints] = useState<TrustPoints[]>([]);

  const dispatch = useDispatch();
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  // const [hiddenValue, setHiddenValue] = useState({
  //   heading: "",
  //   description: "",
  // });
  const [bannerImg, setImg] = useState<string>();
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    localStorage.removeItem("count");
    const imgInsideBanner = datas[0]?.imgInsideBanner;
    setImg(imgInsideBanner);
  }, [datas]);

  const { outsideId, insideId, footerOutsideId } = useSelector(
    (state: {
      ID: { outsideId: string; insideId: string; footerOutsideId: string };
    }) => state.ID
  );

  const addModalOpen = useSelector(
    (state: { modal: { addModelData: boolean } }) => state.modal.addModelData
  );

  const updateModalOpen = useSelector(
    (state: { modal: { updateModelData: boolean } }) =>
      state.modal.updateModelData
  );

  const packageModel = useSelector(
    (state: { modal: { packageModel: boolean } }) => state.modal.packageModel
  );

  const openNewModel = useSelector(
    (state: { modal: { newModel: boolean } }) => state.modal.newModel
  );

  const extractSub1ServiceNames = (data: MainCategory[]): string[] => {
    return data.map((category) => category.sub1ServiceName);
  };

  const sub1ServiceNames = extractSub1ServiceNames(datas);

  useEffect(() => {
    if (datas.length > 0) {
      const subServiceNames = extractSub1ServiceNames(datas);
      const ServiceNames = subServiceNames[0];
      if (ServiceNames) dispatch(setServiceNames({ ServiceNames }));
    }
  }, [datas, dispatch]);

  const [isFixed, setIsFixed] = useState(false);

  useEffect(() => {
    import("./package.css");
    const handleScroll = () => {
      if (window.scrollY > 20) {
        setIsFixed(true);
      } else {
        setIsFixed(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // const getDataFromJson = async (jsonUrl: string) => {
  //   const result = await getJsonData(jsonUrl);
  //   if (result) {
  //     setHiddenValue(result.hidden);
  //   }
  // };

  const cardRef = useRef<HTMLDivElement>(null);
  const wrapperRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const card = cardRef.current;
    const wrapper = wrapperRef.current;
    if (!card || !wrapper) return;

    const handleScroll = () => {
      const cardRect = card.getBoundingClientRect();
      const footer = document.querySelector(".footer");
      if (!footer) return;

      const footerRect = footer.getBoundingClientRect();
      const windowHeight = window.innerHeight;
      let newTop = 16; // 16px = 1rem, relative to wrapper
      if (footerRect.top < windowHeight && footerRect.top <= cardRect.bottom) {
        const spaceAboveFooter = footerRect.top - cardRect.height;
        if (spaceAboveFooter < 16) {
          newTop = Math.max(0, spaceAboveFooter); // Ensure it doesn’t go negative
        }
      }
      card.style.top = `${newTop}px`;
    };

    window.addEventListener("scroll", handleScroll);
    window.addEventListener("resize", handleScroll);
    handleScroll(); // Initial call

    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleScroll);
    };
  }, []);

  const getServices = async () => {
    setIsLoading(true);
    setIsError(false);

    const servicesData = await fetchServices(baseUrl, slug);

    if (servicesData?.mainCategory.length) {
      setData(servicesData.mainCategory);
      setTrustPoints(servicesData.trustPoints);
      // getDataFromJson(servicesData[0]?.jsonUrl);
      const ServiceNames = extractSub1ServiceNames(servicesData.mainCategory)[0];
      if (ServiceNames) dispatch(setServiceNames({ ServiceNames }));
    } else {
      navigate("/notFound");
      setIsError(true);
    }

    setIsLoading(false);
  };

  useEffect(() => {
    getServices();
  }, [slug, dispatch]);

  useEffect(() => {
    const handleScroll = () => {
      const cartdown = document.getElementById("sticky-cart");
      if (cartdown) {
        if (window.innerWidth <= 1200) {
          cartdown.style.marginTop =
            window.scrollY > 700 ? "250px" : `${700 - window.scrollY}px`;
        } else {
          cartdown.style.marginTop =
            window.scrollY > 435 ? "0px" : `${435 - window.scrollY}px`;
        }
      }
    };

    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
      handleScroll();
    };
    handleScroll();
    window.addEventListener("scroll", handleScroll);
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    handleScrollToSectionn(insideId, "inside_");
  }, [datas]);

  useEffect(() => {
    if (insideId) {
      handleScrollToSectionn(insideId, "inside_");
    }
  }, [outsideId, insideId]);

  const handleScrollToSectionn = (insideId: string, ifCheck: string) => {
    if (ifCheck === "inside_" && insideId) {
      const section = document.getElementById("inside_" + insideId);
      if (section) {
        section.scrollIntoView({
          behavior: "smooth",
          block: "start",
          inline: "nearest",
        });
      }
    } else if (outsideId) {
      const section = document.getElementById("outside_" + outsideId);
      if (section) {
        section.scrollIntoView({
          behavior: "smooth",
          block: "start",
          inline: "nearest",
        });
      }
    } else if (footerOutsideId) {
      const section = document.getElementById("outside_" + footerOutsideId);
      if (section) {
        section.scrollIntoView({
          behavior: "smooth",
          block: "start",
          inline: "nearest",
        });
      }
    }
  };
  const [activeId, setActiveId] = useState<string | null>(null);
  const sidebarContainerRef = useRef<HTMLDivElement>(null);
  const sidebarItemRefs = useRef<{ [key: string]: HTMLDivElement | null }>({});
  useEffect(() => {
    const handleScroll = () => {
      const sectionElements: Array<{ id: string; top: number }> = [];
      datas.forEach((category) => {
        category.subCategory.forEach((item) => {
          const el = document.getElementById(`outside_${item.sub2RecordId}`);
          if (el) {
            const rect = el.getBoundingClientRect();
            sectionElements.push({ id: item.sub2RecordId, top: rect.top });
          }
        });
      });
      const threshold = 120; // px from top, adjust as needed
      let currentActiveId: string | null = null;
      for (let i = 0; i < sectionElements.length; i++) {
        if (sectionElements[i].top - threshold <= 0) {
          currentActiveId = sectionElements[i].id;
        } else {
          break;
        }
      }
      if (!currentActiveId && sectionElements.length > 0) {
        currentActiveId = sectionElements[0].id;
      }
      setActiveId((prev) =>
        prev !== currentActiveId ? currentActiveId : prev
      );
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    handleScroll();
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [datas]);
  useEffect(() => {
    if (!activeId) return;
    const activeEl = sidebarItemRefs.current[activeId];
    const container = sidebarContainerRef.current;
    if (activeEl && container) {
      const activeRect = activeEl.getBoundingClientRect();
      const containerRect = container.getBoundingClientRect();
      if (activeRect.top < containerRect.top) {
        activeEl.scrollIntoView({ behavior: "smooth", block: "nearest" });
      } else if (activeRect.bottom > containerRect.bottom) {
        activeEl.scrollIntoView({ behavior: "smooth", block: "nearest" });
      }
    }
  }, [activeId]);

  const handleScrollToSection = (id: string) => {
    const section = document.getElementById("outside_" + id);
    if (section) {
      section.scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "nearest",
      });
    }
  };

  const isImage = (src: string | undefined) => {
    return /\.(jpg|jpeg|png|gif|webp)$/i.test(src ?? ""); // Regex to test for common image extensions
  };

  const [isFloatingSectionVisible, setIsFloatingSectionVisible] =
    useState(false);

  const toggleFloatingSection = () => {
    setIsFloatingSectionVisible(!isFloatingSectionVisible);
    if (document.body.classList.contains("bd-overlay")) {
      document.body.classList.remove("bd-overlay");
    } else {
      document.body.classList.add("bd-overlay");
    }
  };

  const setIsFloatingSectionVisibleMakeFalse = () => {
    setIsFloatingSectionVisible(false);
    document.body.classList.remove("bd-overlay");
  };

  if (isLoading) {
    return (
      <>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            height: "100dvh",
          }}
        >
          <PreLoader />
        </div>
      </>
    );
  }

  if (isError) {
    return null;
  }

  return (
    <>
      <section className="inner-wrapper py-0 py-md-5">
        <div className="container">
          <div className="row">
            {/* Conditional rendering of the div based on isVisible */}

            <div className="col-12 pick-service-wrap">
              <div className="services-list-banner d-none col-12">
                {/* <img src={banner} className="img-fluid d-block mx-auto" alt="" /> */}
                <div className="banner-caption-wrapper">
                  <div className="banner-caption">
                    {/* Amer Services */}
                    <h2>{sub1ServiceNames} Services</h2>
                  </div>
                </div>
              </div>

              <div
                ref={cardRef}
                className="card border-0 pb-0 rounded sd-card  mb-4 t-5"
                style={{
                  position: "sticky",
                  top: "100px", // Initial sticky position
                  zIndex: 1,
                  transition: "top 0.3s ease", // Smooth movement
                }}
              >
                {/* 
              ${isSticky ? "position-fixed " : "overflow-auto" }
              
              <div
                className={`card border-0 pb-0 rounded sd-card ${isSticky ? "position-fixed " : ""
                  } sticky-offset z-index-0 mb-4 t-5 `}
                ref={cartRef}
              > */}
                {/* <div style={{ height: "0px" }}>
                  <h1
                    dangerouslySetInnerHTML={{
                      __html: hiddenValue?.heading ?? "",
                    }}
                  ></h1>
                  <p
                    dangerouslySetInnerHTML={{
                      __html: hiddenValue?.description ?? "",
                    }}
                  ></p>
                </div> */}
                <div className="font-25 mb-2 ff-semibold py-0">
                  Residency {sub1ServiceNames} Services
                </div>

                {isMobile && <SecondRightSideCard isMobile={isMobile} />}

                <div
                  className="catg-card"
                  ref={sidebarContainerRef}
                  style={{ maxHeight: "60vh", overflow: "hidden" }}
                >
                  <div className="d-md-flex align-items-center justify-content-start mb-3 gap-3 d-none">
                    <span className="ff-semibold mt-0 mb-0 mr-3 text-capitalize font-12 select-course-heading text-sec">
                      Select Your Package
                    </span>
                    <div className="line flex-grow-1"></div>
                  </div>

                  <div className="row sideCard-res">
                    <div className="row d-md-none d-lg-none d-xl-flex flex-wrap">
                      {datas.map((category) =>
                        category.subCategory.map((item) => (
                          <div
                            key={`sidebar-${item.sub2RecordId}`}
                            className="col-md-4 col-3 px-1"
                            style={{ cursor: "pointer" }}
                            ref={(el) =>
                              (sidebarItemRefs.current[item.sub2RecordId] = el)
                            }
                          >
                            <div
                              className={`cat-small-card pk position-relative  my-1 my-md-3  ${
                                activeId === item.sub2RecordId ? "active" : ""
                              }`}
                              onClick={() => {
                                handleScrollToSection(item.sub2RecordId);
                                setActiveId(item.sub2RecordId);
                              }}
                            >
                              <div>
                                <img
                                  src={item.SrcThumbnail}
                                  className="d-block mx-auto cat-icon "
                                  alt={item.sub2ImgAlt}
                                  style={{ objectFit: "cover" }}
                                />
                              </div>
                              <div className="text-center pt-2 animate-Line">
                                <p className="checkout-ser-name  text-center mb-2">
                                  {item.sub2ServiceName}
                                </p>
                              </div>
                            </div>
                          </div>
                        ))
                      )}
                    </div>

                    <div className="d-lg-block d-md-block d-none d-xl-none">
                      <Swiper
                        modules={[Navigation, Pagination, A11y, Autoplay]}
                        spaceBetween={30}
                        slidesPerView={7}
                        loop={true}
                        autoplay={{
                          delay: 2500,
                          disableOnInteraction: false,
                        }}
                        breakpoints={{
                          1300: {
                            slidesPerView: 3, // Tablet max width 1200px
                            spaceBetween: 5,
                          },
                        }}
                      >
                        {datas.map((category) =>
                          category.subCategory.map((item) => (
                            <SwiperSlide
                              key={`sidebar-${item.sub2RecordId}`}
                              className="bg-transparent"
                            >
                              <TooltipLink
                                title={item.sub2ServiceName}
                                Id={item.sub2RecordId}
                                styleName="none"
                              >
                                <div
                                  className="cat-small-card my-3 my-md-3"
                                  onClick={() =>
                                    handleScrollToSection(item.sub2RecordId)
                                  }
                                >
                                  <div>
                                    <img
                                      src={item.SrcThumbnail}
                                      className="d-block mx-auto cat-icon"
                                      alt={item.sub2ImgAlt}
                                    />
                                  </div>
                                  <div className="text-center pt-2">
                                    <p className="checkout-ser-name text-center">
                                      {item.sub2ServiceName}
                                    </p>
                                  </div>
                                </div>
                              </TooltipLink>
                            </SwiperSlide>
                          ))
                        )}
                      </Swiper>
                    </div>
                  </div>

                  <FloatingMenuSection
                    isVisible={isFloatingSectionVisible}
                    datas={datas}
                    setIsFloatingSectionVisibleMakeFalse={
                      setIsFloatingSectionVisibleMakeFalse
                    }
                  />
                </div>
              </div>
            </div>
            <FloatingMenuButton
              onTouchStart={toggleFloatingSection}
              isFloatingSectionVisible={isFloatingSectionVisible}
            />

            <div className="col-lg-12  col-12 pick-service-content-wrap">
              <div className="row py-3">
                <div className="col-lg-7 col-md-12 col-12">
                  <div
                    className="services-list-banner "
                    style={{ width: "100%" }}
                  >
                    {/* <img
                  loading="lazy"
                  src={bannerImg}
                  className="img-fluid d-block mx-auto"
                  alt="bannerImg"
                /> */}
                    {isImage(bannerImg) ? (
                      <img
                        loading="lazy"
                        src={bannerImg}
                        className="img-fluid d-block mx-auto"
                        alt="bannerImg"
                      />
                    ) : (
                      <video
                        style={{
                          borderRadius: "8px",
                          height: "261x",
                          width: "100%",
                          objectFit: "cover",
                          marginTop: isFixed ? "-41px" : "0",
                        }}
                        key={`video-banner-${bannerImg}`}
                        autoPlay
                        loop
                        muted
                        playsInline
                        controlsList="nodownload nofullscreen noremoteplayback"
                      >
                        <source src={bannerImg} type="video/mp4" />
                        Your browser does not support the video tag.
                      </video>
                    )}
                  </div>

                  {datas.map((category) =>
                    category.subCategory.map((categories) => (
                      <div
                        className="serv-list-wrap"
                        key={`outside_${categories.sub2RecordId}`}
                        id={`outside_${categories.sub2RecordId}`}
                      >
                        <div className="w-100 text-center bg-3 p-2  rounded-2 mt-2 d-none">
                          <p className="ff-normal font-13 text-primary mb-0">
                            {/* Live, Invest, and Thrive in the UAE,{" "}
                            <span className=" ff-semibold">
                              Unlock It with a Golden Visa
                            </span> */}
                            {categories.sub2Description}
                          </p>
                        </div>
                        <div className="font-22 ff-bold text-black py-2">
                          {categories.sub2ServiceName}
                        </div>
                        {/* <div>
                          <p className="font-13 ff-normal text-mute ">
                            The UAE Golden Visa is awarded to investors,
                            talents, professionals, and humanitarians. Choose
                            our package for expert guidance, fast processing,
                            and fully compliant, premium medical test and
                            residency support.
                          </p>
                        </div> */}
                        {/* <p className="font-13 ff-normal text-mute">
                          {categories.sub2Description}
                        </p> */}

                        <PackageList
                          allServices={categories.services}
                          slug={slug ?? ""}
                          mainCatName={category.sub1ServiceName}
                        />
                        <hr className="border border-1 opacity-100" />
                      </div>
                    ))
                  )}
                </div>

                {addModalOpen && <Model />}
                {updateModalOpen && <UpdateModel />}
                {packageModel && <PackageDescriptionModel />}
                {openNewModel && <NewModel />}
                {/* {newPackageModel && <PackageFlowModel/>} */}
                <HandleModel />
                <HandleReadFullPolicyModel />
                <HandlePackageAndServiceModel />
                <div className="col-lg-5 d-none d-lg-block ">
                  <div
                    ref={cardRef}
                    className="card border-0 pb-0 rounded sd-card cartdown mb-4 t-5"
                    style={{
                      position: "sticky",
                      top: "100px",
                      zIndex: 1,
                      transition: "top 0.3s ease",
                    }}
                  >
                    {/* is compenent ma cartinfonew api lagani ha */}
                    <CartPackage hide={true} />
                    <ChatWithUs />
                    <Coupons />
                    {/* <SecondRightSideCard isMobile={isMobile} /> */}
                    <SideCard trustPoints={trustPoints || []} sideCardtitle={datas[0]?.sideCardtitle || ""} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default PackagesMain;
